<div class="main-box position-relative">
  <div class="position-relative p-3">
    <div class="summary-border border bg-light p-4 mb-3 border-radius-4">
      <div class="d-flex p-2 float-end sticky-button">
        <button (click)="exportList()" type="button" class="btn btn-primary-datalist ms-3">
          <i class="fa-solid fa-download"></i>
          <span class="hidebuttonName"> EXPORT</span>
        </button>
      </div>
      <table class="table utility-table">
        <tbody>
          <tr>
            <td>
              <div class="summary-text h-48">
                <label class="fw-bold mb-0 d-flex align-content-center"
                  >{{ labelConstants.TotalCosts }} ({{
                    env.CurrencySymbol
                  }})</label
                >
              </div>
            </td>
            <td>
              <div class="input-group">
                <span class="input-group-text">{{ env.CurrencySymbol }}</span>
                <input
                  type="text"
                  class="form-control bg-white"
                  [disabled]="true"
                  [value]="
                    detail.totalUtilityCost | custom : env.CurrencyFormat
                  "
                  readonly
                />
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="summary-text h-48">
                <label class="fw-bold mb-0">{{
                  labelConstants.BusinessAverage
                }}</label>
              </div>
            </td>
            <td>
              <div
                class="d-flex align-items-center gap-2 flex-wrap flex-lg-nowrap"
              >
                <div class="input-group">
                  <ng-select
                    [disabled]="true"
                    [items]="businessAverageOptions"
                    (change)="calculate()"
                    class="w-100"
                    [(ngModel)]="selectedBusinessAverageOption"
                    bindLabel="value"
                    bindValue="id"
                    autocomplete="nope"
                    placeholder="Select Business Average."
                  >
                  </ng-select>
                </div>
                <div class="input-group">
                  <span class="input-group-text">%</span>
                  <input
                    type="text"
                    class="form-control bg-white"
                    [(ngModel)]="businessAverage"
                    [disabled]="true"
                    [readOnly]="selectedBusinessAverageOption == 1"
                    (input)="businessAverageChange()"
                    oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/^(\d*\.\d{0,2}).*/, '$1');"
                  />
                  <mat-icon
                    *ngIf="selectedBusinessAverageOption == 2"
                    matTooltip="Where business Average is not a suitable method of allocation, please insert other suitable allocation percentage."
                    class="ms-2 cursor-pointer mt-2"
                    >info</mat-icon
                  >
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="summary-text h-48">
                <label class="fw-bold mb-0"
                  >{{ labelConstants.QualifyingCosts }} ({{
                    env.CurrencySymbol
                  }})</label
                >
              </div>
            </td>
            <td>
              <div class="input-group">
                <span class="input-group-text">{{ env.CurrencySymbol }}</span>
                <input
                  type="text"
                  class="form-control bg-white"
                  [disabled]="isLocked"
                  [value]="totalQualifyingCosts | custom : env.CurrencyFormat"
                  readonly
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <app-loader [count]="10" [appearance]="'line'" [isLoading]="isLoading">
      <div class="claim-table">
        <div class="table-container">
          <!-- <div class="table-responsive"> -->
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th></th>
                  <th>
                    {{ labelConstants.TotalQualifyingCosts }} ({{
                      env.CurrencySymbol
                    }})
                  </th>
                  <th *ngFor="let item of projectList" class="equal-width-col">
                    {{ item.projectName }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{ labelConstants.UtilityCosts }} ({{ env.CurrencySymbol }})
                  </td>
                  <td>
                    {{
                      totalQualifyingCosts | customCurrency : env.CurrencyFormat
                    }}
                  </td>
                  <ng-container
                    *ngFor="let item of detail.projects; let i = index"
                  >
                    <td class="equal-width-col">
                      {{ item.utilityCosts ? item.utilityCosts.toFixed(2) : 0 }}
                      %
                    </td>
                  </ng-container>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td>
                    <b>{{ labelConstants.Utilities }}</b>
                  </td>
                  <td></td>
                  <td *ngFor="let total of utilityTotals">
                    <b>{{ total | customCurrency : env.CurrencyFormat }}</b>
                  </td>
                </tr>
              </tfoot>
            </table>
          <!-- </div> -->
        </div>
      </div>
    </app-loader>
    <div class="submit-box mx-auto text-center mt-2 mb-2 d-block">
      <button
        [disabled]="isLocked || !havePermission"
        type="button"
        (click)="save()"
        class="btn btn-primary w-25"
      >
        {{ commonLabelConstants.Save }}
      </button>
    </div>
  </div>
</div>
